module.exports = __webpack_public_path__ + "img/aParty_1208_B.b2b9dfa3.jpg";